<template>
  <g :style="{
    transform: `translate(${x}px,${y}px)`
  }">
    <text id="total points" text-anchor="middle" fill="black" xml:space="preserve" style="white-space: pre" font-weight="bold" font-family="Poppins, Helvetica neue, Helvetica" font-size="18" letter-spacing="0em">
        <tspan :x="width/2" y="1em">{{ label }}</tspan>
    </text>
    <g :style="{
      transform: `translate(0px, ${labelHeight}px)`
    }">
      <rank-item :rank="rank" v-for="(rank,i) in ranks" :key="i" :width="width" :height="itemHeight" :y="i * (itemHeight + listMargin)"  />
    </g>
  </g>
</template>

<script>
import RankItem from './RankItem'
export default {
  components:{
    RankItem,
  },
  props:['height','width','x','y', 'label', 'ranks'],
  data(){
    return {
      listMargin: 10,
      labelHeight: 30,
    }
  },
  computed:{
    listHeight(){
      return this.height - this.labelHeight
    },
    total(){
      return this.ranks.length
    },
    itemHeight(){
      return (this.listHeight - (this.total * this.listMargin - this.listMargin))/this.total
    }
  }
}
</script>